module.exports = __webpack_public_path__ + "img/card-3.8099c0d0.png";